import { render, staticRenderFns } from "./studyColumn.vue?vue&type=template&id=559cb43a&scoped=true&"
import script from "./studyColumn.vue?vue&type=script&lang=js&"
export * from "./studyColumn.vue?vue&type=script&lang=js&"
import style0 from "./studyColumn.vue?vue&type=style&index=0&id=559cb43a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559cb43a",
  null
  
)

export default component.exports